import {
    getExpenditure,
    setRequestOption,
    setApprovalOrderRequest,
    submitOrderApprovalRequest,
    setIsOrderApprovalComplete,
    setGridColumns,
    getOrdersStatus,
    cancelOrderReq,
    setIsOrderCanceled,
    getActionPopupValue
} from './action'

const getExpenditureDetail = (dispatch: Function) => (data: any) => {
    dispatch(getExpenditure(data));
}

const setRequestOptionDetail = (dispatch: Function) => (data: any) => {
    dispatch(setRequestOption(data));
}

const dispatchSetApprovalOrderRequest = (dispatch: Function) => (approvalOrderRequest: any) => {
    dispatch(setApprovalOrderRequest(approvalOrderRequest));
}

const dispatchSubmitOrderApprovalRequest = (dispatch: Function) => (submitOrderRequest: any) => {
    dispatch(submitOrderApprovalRequest(submitOrderRequest));
}

const dispatchSetIsOrderApprovalComplete = (dispatch: Function) => (isOrderApprovalComplete: any) => {
    dispatch(setIsOrderApprovalComplete(isOrderApprovalComplete));
}

const dispatchSetGridColumns = (dispatch: Function) => (gridColumns: any) => {
    dispatch(setGridColumns(gridColumns));
}

const dispatchGetOrdersStatus = (dispatch: Function) => () => {
    dispatch(getOrdersStatus());
}

const dispatchCancelOrderRequest = (dispatch: Function) => (cancelOrderRequest: any) => {
    dispatch(cancelOrderReq(cancelOrderRequest));
}

const dispatchSetIsOrderCanceled = (dispatch: Function) => (isOrderCanceled: any) => {
    dispatch(setIsOrderCanceled(isOrderCanceled));
}
const dispatchActionPopup = (dispatch:Function) => (data:any) => {
    dispatch(getActionPopupValue(data));
    };
const operations = {
    getExpenditureDetail,
    setRequestOptionDetail,
    dispatchSetApprovalOrderRequest,
    dispatchSubmitOrderApprovalRequest,
    dispatchSetIsOrderApprovalComplete,
    dispatchSetGridColumns,
    dispatchGetOrdersStatus,
    dispatchCancelOrderRequest,
    dispatchSetIsOrderCanceled,
    dispatchActionPopup

}

export default operations
